import { PATHWAY } from "@/constants/testIds";
import {
  CONTROL_CENTRE_FOOTNOTE,
  CONTROL_CENTRE_TILES,
} from "@/lib/pathwayData";
import { SectionEyebrow } from "@/components/pathway/Journey";
import RuntimeStatusPanel from "@/components/pathway/RuntimeStatusPanel";

const toneColor = {
  ok: "text-amber-500",
  warn: "text-[#dc2626]",
  muted: "text-neutral-100",
};

export default function GovernanceCentre() {
  return (
    <section
      id="governance-centre"
      data-testid={PATHWAY.governanceCentre}
      className="border-t hairline bg-[#0a0a0a]"
    >
      <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-28">
        <div className="grid gap-8 md:grid-cols-[1.2fr_1fr] md:items-end md:gap-16">
          <div>
            <SectionEyebrow>Operational governance centre</SectionEyebrow>
            <h2 className="mt-4 font-serif text-3xl leading-tight tracking-tight text-neutral-50 sm:text-4xl lg:text-5xl">
              Runtime governance, at a glance.
            </h2>
          </div>
          <p className="text-neutral-400">
            What KATLAS looks like at runtime: governed decisions, pending
            authority, conflicted instructions, operational receipts, escalated
            exceptions and decision provenance — all attributable to a role and
            a moment in time.
          </p>
        </div>

        <div className="mt-14 grid gap-10 lg:grid-cols-[1fr_360px] lg:gap-12">
          <div className="grid grid-cols-1 border-l hairline sm:grid-cols-2 lg:grid-cols-3">
            {CONTROL_CENTRE_TILES.map((t) => (
              <article
                key={t.slug}
                data-testid={PATHWAY.controlTile(t.slug)}
                className="border-b border-r hairline p-8 md:p-10"
              >
                <div
                  className={`font-serif text-5xl leading-none tracking-tight md:text-6xl ${
                    toneColor[t.tone] || "text-neutral-50"
                  }`}
                >
                  {t.value}
                </div>
                <div className="mt-5 text-[15px] leading-snug text-neutral-100">
                  {t.label}
                </div>
                <div className="mt-3 font-mono text-[11px] leading-relaxed tracking-wide text-neutral-500">
                  {t.note}
                </div>
              </article>
            ))}
          </div>

          <div className="lg:sticky lg:top-24 lg:self-start">
            <RuntimeStatusPanel />
          </div>
        </div>

        <div className="mt-8 border-t hairline pt-5 font-mono text-[10px] uppercase tracking-[0.24em] text-neutral-500">
          {CONTROL_CENTRE_FOOTNOTE}
        </div>
      </div>
    </section>
  );
}
